module.exports = __webpack_public_path__ + "img/1.07ecb863.jpg";